import React from 'react';

interface Props {
  title: string;
  items: string[];
  action?: React.ReactNode;
  active?: boolean;
  color?: 'blue' | 'green';
}

const bgColors = {
  blue: 'bg-btn',
  green: 'bg-card-green',
};

const gradientColors = {
  blue: 'from-[#EBF4FF]/60',
  green: 'from-[#DCF9F4]/60',
};

const titleColors = {
  blue: 'text-active',
  green: 'text-[#00AE7F]',
};
export const InventoryCard = (props: Props) => {
  const { title, items, action, active } = props;
  const color = props.color || 'blue';
  const activeBg = `bg-gradient-to-br ${gradientColors[color]} from-20% to-white to-50%`;
  const activeTitleColor = titleColors[color];
  return (
    <div
      className={`flex-1 p-8 rounded-2xl mobile:p-5 ${
        active ? bgColors[color] : 'bg-bg'
      }`}
    >
      <div className="rounded-lg bg-white h-full shadow-card border border-[#fff]">
        <div
          className={`flex p-7 rounded-lg flex-col h-full ${
            active ? activeBg : ''
          }`}
        >
          <div className="text-active text-2xl font-bold leading-[34px]">
            <span
              className={`line-clamp-1 ${
                active ? activeTitleColor : 'text-primary'
              }`}
            >
              {title}
            </span>
          </div>
          <div className="h-px my-[30px] w-full bg-black/[.06]" />
          <div className="pl-1 flex-1">
            <ListInventoryCard data={items} />
          </div>
          {action && <div className="h-px my-5 bg-primary/[.08]" />}
          {action}
        </div>
      </div>
    </div>
  );
};

const ListInventoryCard = ({ data = [] }: { data: Props['items'] }) => {
  return (
    <ul className="flex flex-col gap-y-1">
      {data.map((item, index) => (
        <li key={index} className="flex items-center gap-x-1">
          <span className="text-sm  break-all">{item}</span>
        </li>
      ))}
    </ul>
  );
};
